export default "__VITE_ASSET__C6rJMNv0__"